import React from 'react';
import styled from 'styled-components';

const HeroSection = styled.section`
  background: linear-gradient(135deg, #e1f5fe 0%, #b3e5fc 100%);
  padding: 80px 0;
  position: relative;
  overflow: hidden;
  
  @media (max-width: 768px) {
    padding: 60px 0;
  }
`;

const HeroContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  
  @media (max-width: 992px) {
    flex-direction: column;
    text-align: center;
  }
`;

const HeroContent = styled.div`
  flex: 1;
  padding-right: 40px;
  
  @media (max-width: 992px) {
    padding-right: 0;
    margin-bottom: 40px;
  }
`;

const HeroTitle = styled.h1`
  font-size: 42px;
  color: #6a1b9a;
  margin-bottom: 20px;
  
  @media (max-width: 768px) {
    font-size: 32px;
  }
`;

const HeroSubtitle = styled.p`
  font-size: 18px;
  color: #555;
  margin-bottom: 30px;
  line-height: 1.6;
`;

const HeroButton = styled.a`
  display: inline-block;
  background-color: #ff6f00;
  color: white;
  padding: 12px 30px;
  border-radius: 30px;
  text-decoration: none;
  font-weight: bold;
  font-size: 16px;
  transition: background-color 0.3s;
  
  &:hover {
    background-color: #ff9100;
  }
`;

const HeroImage = styled.div`
  flex: 1;
  
  img {
    max-width: 100%;
    border-radius: 10px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  }
`;

const Hero = () => {
  return (
    <HeroSection>
      <HeroContainer>
        <HeroContent>
          <HeroTitle>Ateliê Dentinhos de Leite: Clínica de Odontopediatria</HeroTitle>
          <HeroSubtitle>
            Aqui, cada consulta é uma experiência única e divertida, onde o conforto e bem-estar dos pequenos são nossa prioridade. 
            Cuidamos da saúde bucal com amor e profissionalismo, unindo tecnologia de ponta com muito carinho, garantindo sorrisos felizes e radiantes.
          </HeroSubtitle>
          <HeroButton href="/agendar">Agende a consulta para seu filho</HeroButton>
        </HeroContent>
        <HeroImage>
          <img src="/hero-placeholder.jpg" alt="Crianças sorridentes no consultório" />
        </HeroImage>
      </HeroContainer>
    </HeroSection>
  );
};

export default Hero;
